export const displayPrice = (price) => `${price},000đ`;
